<template>
    <div>
        <router-view v-show="$route.meta.hasOwnProperty('detail') && $route.meta.detail"></router-view>
        <div class="wrap" v-show="!$route.meta.hasOwnProperty('detail') || !$route.meta.detail">
            <div class="container lnb">
                <div class="contents_wrap">
                    <div class="contents">
                        <div class="title">
                            {{ $route.meta.title }}
                            <div class="clear"></div>
                        </div>
                        <delivery-write-component :deliveryType="`delivery`"></delivery-write-component>
                        <div class="mt15 text_center">
                            <el-button type="primary" @click="save">저장</el-button>
                        </div>
                    </div>
                    <page-footer></page-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DeliveryWriteComponent from "../../components/delivery/DeliveryWriteComponent";
import EventBus from "@/mixins/event-bus";
export default {
    name: "Delivery",
    components: {
        DeliveryWriteComponent
    },
    props: {},
    data() {
        return {}
    },
    created() {},
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save(){
            EventBus.$emit('writeDelivery')
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>